import { buildModelManager } from "../builder.js";
const DefaultLiveAudioChunkSelection = {
  __typename: true,
  id: true,
  chunkAudio: { url: true, mimeType: true, fileName: true },
  confidence: true,
  correctedTranscript: { markdown: true, truncatedHTML: true },
  correctionFlags: true,
  createdAt: true,
  createdById: true,
  durationMs: true,
  endedAt: true,
  errorMessage: true,
  institution: true,
  participantRole: true,
  processingMetadata: true,
  processingStatus: true,
  rawTranscript: { markdown: true, truncatedHTML: true },
  runId: true,
  seq: true,
  simulationSessionId: true,
  sourceId: true,
  sourceLabel: true,
  speakerLabel: true,
  startedAt: true,
  updatedAt: true
};
const modelApiIdentifier = "liveAudioChunk";
const pluralModelApiIdentifier = "liveAudioChunks";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultLiveAudioChunkSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "liveAudioChunkGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const LiveAudioChunkManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultLiveAudioChunkSelection,
  operations
);
export {
  DefaultLiveAudioChunkSelection,
  LiveAudioChunkManager
};
//# sourceMappingURL=LiveAudioChunk.js.map
